import DebitForm from './DebitForm';

const DebitPayment = (): JSX.Element => {
    return (
        <div className="donor-debit-payment-wrapper">
            <DebitForm />
        </div>
    );
};

export default DebitPayment;
